module.exports = __webpack_public_path__ + "img/discover.7512622f.png";